<template>
  <div class="page">
    <main class="card">
      <div class="kicker">Anmeldung</div>
      <h1 class="title">Wird verarbeitet …</h1>
      <div v-if="!error" class="spinner" aria-label="Lädt"></div>
      <p v-if="!error" class="subtitle">Token wird abgeholt.</p>

      <template v-else>
        <div class="error">{{ error }}</div>
        <button class="linkbtn" @click="goHome">Zurück zur Startseite</button>
      </template>
    </main>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { CallbackError, handleCallback } from '../services/auth';

const route = useRoute();
const router = useRouter();
const error = ref<string | null>(null);

onMounted(async () => {
  const code  = (route.query.code  as string | undefined) ?? '';
  const state = (route.query.state as string | undefined) ?? '';

  if (!code || !state) {
    error.value = 'Anmeldung fehlgeschlagen: fehlende Parameter.';
    return;
  }

  try {
    await handleCallback(code, state);
    router.replace({ name: 'dashboard' });
  } catch (e) {
    if (e instanceof CallbackError && e.code === 'state_mismatch') {
      error.value = 'Anmeldung konnte nicht verifiziert werden.';
    } else {
      error.value = 'Anmeldung fehlgeschlagen.';
    }
    console.error(e);
  }
});

function goHome() {
  router.replace({ name: 'home' });
}
</script>
